import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { sortFromSearch, writeSort, type SortState } from '@/lib/sort-url'

export function useDeskSort(allowed: readonly string[]) {
  const [sp, setSp] = useSearchParams()
  const allow = useMemo(() => new Set(allowed), [allowed.join('\0')])
  useEffect(() => {
    const cur = new URLSearchParams(sp)
    const before = cur.toString()
    sortFromSearch(cur, allow)
    if (cur.toString() !== before) setSp(cur, { replace: true })
  }, [sp, setSp, allow])
  const sort = sortFromSearch(new URLSearchParams(sp), allow)
  const onSortChange = (next: SortState) => {
    const cur = new URLSearchParams(sp)
    writeSort(cur, next)
    cur.set('page', '1')
    setSp(cur, { replace: true })
  }
  return { sort, onSortChange, sortQuery: sort ? { sort: sort.key, order: sort.order } : {} }
}
